import type { NDateLocale } from './enUS'
import { da } from 'date-fns/locale'

const dateDaDK: NDateLocale = {
  name: 'da-DK',
  locale: da
}

export default dateDaDK
